import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { useIsFirstRenderRef } from '#/hooks/useIsFirstRenderRef';
import { authLoginAuthRequiredSearchParam } from '#/modules/auth/routing/auth.routes';
import {
  clearFlashMessages,
  pushFlashMessage,
} from '#/zustand-stores/flashMessagesStore';
import { useHorizonFlashMessageActions } from '#/zustand-stores/horizonFlashMessageStore';

export function SetFlashMessagesGlobalHandler() {
  const [searchParams] = useSearchParams();
  const location = useLocation<{ flashMessage?: FlashMessageType }>();

  const { isFirstRenderRef } = useIsFirstRenderRef();
  const { clearHorizonFlashMessage } = useHorizonFlashMessageActions();

  useEffect(() => {
    if (isFirstRenderRef.current) return;
    clearFlashMessages();
    clearHorizonFlashMessage();
  }, [isFirstRenderRef, location.pathname, clearHorizonFlashMessage]);

  const locationStateFlashMessage = location.state?.flashMessage;
  const pushLoginRequired = searchParams.has(authLoginAuthRequiredSearchParam);
  useEffect(() => {
    if (locationStateFlashMessage) pushFlashMessage(locationStateFlashMessage);
    if (pushLoginRequired) pushFlashMessage({ type: 'LOGIN_REQUIRED' });
  }, [locationStateFlashMessage, pushLoginRequired]);

  return null;
}
